import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function AboutSection() {
  return <section id="about" className="py-20 bg-white" data-id="element-17" data-mp="2lbnbbns8snre">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18" data-mp="2la3rxobahwle">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-19" data-mp="2gc2at8xfc7ck">
          <AnimatedSection data-id="element-20" data-mp="2be91i70tqx82">
            <div className="relative mb-12 lg:mb-0" data-id="element-21" data-mp="2bcz6jqp9q55n">
              <div className="aspect-w-3 aspect-h-2 rounded-2xl overflow-hidden shadow-2xl" data-id="element-22" data-mp="27cf88jsykvhx">
                <img src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Experiential event production with dynamic lighting" className="w-full h-full object-center object-cover" data-id="element-23" data-mp="27e8cjsg3n3mr" />
              </div>
              <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-indigo-50 rounded-2xl -z-10" data-id="element-24" data-mp="1noobj4696zpa"></div>
            </div>
          </AnimatedSection>
          <AnimatedSection delay={0.2} data-id="element-25" data-mp="1joxjyy8wkfjp">
            <div data-id="element-26" data-mp="srt11jt48p2q">
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6" data-id="element-27" data-mp="sravtxoh70io">
                Why Sales Leaders Choose Turnout
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-28" data-mp="itwul5b4iiay">
                You know your buyers are in those rooms. But without a field
                marketer in the seat, events stay an unbudgetable line item you
                cannot forecast or compare against outbound. So the spend gets
                justified after the fact, or it never gets approved at all.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-29" data-mp="12i5vq4un9yml">
                Turnout makes events behave like an ads manager. We pick the
                events, fill the room, book the meetings, and report the ROI. A
                short intake gets you an events calendar and a first event
                within two weeks. After that it is 30 minutes a week reviewing
                spend, forecast, and actuals.
              </p>
              <div className="grid grid-cols-2 gap-6 text-center" data-id="element-30" data-mp="1xpod9x7fymkb">
                <AnimatedSection delay={0.4} data-id="element-31" data-mp="1srd31ld8ia1k">
                  <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-32" data-mp="1ssodg416qg1n">
                    <p className="text-4xl font-bold text-indigo-600 mb-1" data-id="element-33" data-mp="1nzlibrgreyjc">
                      5x
                    </p>
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-34" data-mp="1j00hfbi14g3z">
                      Return on Spend
                    </p>
                  </div>
                </AnimatedSection>
                <AnimatedSection delay={0.5} data-id="element-35" data-mp="152bzocj9dp35">
                  <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-36" data-mp="1533j6ozkzwd2">
                    <p className="text-4xl font-bold text-indigo-600 mb-1" data-id="element-37" data-mp="1040r054p9kmi">
                      2 wks
                    </p>
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-38" data-mp="2zftftehc3jo5">
                      To First Event
                    </p>
                  </div>
                </AnimatedSection>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}